import { styled } from "@mui/material/styles";

const StyledFavItems = styled("div")(
  ({ theme }) => `

  .main-container{
  width: 100%;
  height: calc(100vh - 110px);
  background-color:${theme.palette.customColor.white};
}
  .product-container {
    display: flex;
    align-items: center;
    gap: 12px; 
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    text-transform: capitalize;

    @media (max-width: 600px){
        font-size: 12px;
}


}

.image-product {
    max-width: 40px !important;
    max-height: 40px !important;
    object-fit: cover !important;
}

.icon-no-data{
font-size: 30px;
}
`
);

export default StyledFavItems;